import { Mic, Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

const BRAND_GRADIENT = "linear-gradient(135deg, #4E9CFF 0%, #FF4DB8 100%)";

interface VoiceInputButtonProps {
  isListening: boolean;
  isTranscribing?: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

const VoiceInputButton = ({ isListening, isTranscribing, onToggle, disabled }: VoiceInputButtonProps) => (
  <button
    type="button"
    onClick={onToggle}
    disabled={disabled || isTranscribing}
    className={cn(
      "shrink-0 h-11 w-11 rounded-xl flex items-center justify-center transition-all",
      "disabled:opacity-30 disabled:cursor-not-allowed",
      isListening
        ? "text-white animate-pulse"
        : isTranscribing
          ? "text-white opacity-80"
          : "bg-gray-100 text-gray-500 hover:bg-gray-200",
    )}
    style={isListening || isTranscribing ? { background: BRAND_GRADIENT } : undefined}
    aria-label={isTranscribing ? "Transcribing..." : isListening ? "Stop listening" : "Voice input"}
  >
    {isTranscribing ? (
      <Loader2 className="h-5 w-5 animate-spin" />
    ) : (
      <Mic className="h-5 w-5" />
    )}
  </button>
);

export default VoiceInputButton;
